import React from 'react';
import { FadeIn } from './FadeIn';
import { Timer, Utensils } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function RecipeTeaser() {
  const recipes = [{
    name: 'Muffins Proteicos de Huevo',
    time: '10 min',
    type: 'Desayuno',
    image: 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?auto=format&fit=crop&w=600&q=80'
  }, {
    name: 'Nuggets Caseros',
    time: '15 min',
    type: 'Almuerzo',
    image: 'https://images.unsplash.com/photo-1562967914-608f82629710?auto=format&fit=crop&w=600&q=80'
  }, {
    name: 'Chips de Batata',
    time: '15 min',
    type: 'Guarnición',
    image: 'https://images.unsplash.com/photo-1635774855536-9728f2610245?auto=format&fit=crop&w=600&q=80'
  }, {
    name: 'Pollo Especiado',
    time: '18 min',
    type: 'Cena',
    image: 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?auto=format&fit=crop&w=600&q=80'
  }];
  return <section className="py-24 bg-stone-50" data-id="element-214">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-215">
        <FadeIn data-id="element-216">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12" data-id="element-217">
            <div className="max-w-2xl" data-id="element-218">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-stone-900 mb-4" data-id="element-219">
                Recetas fáciles, rápidas y saciantes
              </h2>
              <p className="text-lg text-stone-600" data-id="element-220">
                Seleccionadas porque son fáciles de preparar, utilizan
                ingredientes comunes y te ayudan a mantener la saciedad.
              </p>
            </div>
            <div className="shrink-0" data-id="element-221">
              <div className="inline-flex items-center gap-2 bg-white border border-stone-200 px-4 py-2 rounded-full text-sm font-bold text-stone-700 shadow-sm" data-id="element-222">
                <Timer className="w-4 h-4 text-brand-500" data-id="element-223" />
                Menos de 20 minutos
              </div>
            </div>
          </div>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-224">
          {recipes.map((recipe, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-225">
              <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all group border border-stone-100" data-id="element-226">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-227">
                  <img src={recipe.image} alt={recipe.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-228" />
                  <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-stone-800 shadow-sm" data-id="element-229">
                    {recipe.type}
                  </div>
                </div>
                <div className="p-5" data-id="element-230">
                  <h3 className="font-bold text-stone-900 text-lg mb-3 leading-tight" data-id="element-231">
                    {recipe.name}
                  </h3>
                  <div className="flex items-center gap-4 text-sm text-stone-500 font-medium" data-id="element-232">
                    <div className="flex items-center gap-1.5" data-id="element-233">
                      <Timer className="w-4 h-4" data-id="element-234" />
                      {recipe.time}
                    </div>
                    <div className="flex items-center gap-1.5" data-id="element-235">
                      <Utensils className="w-4 h-4" data-id="element-236" />
                      Airfryer
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.2} data-id="element-237">
          <div className="text-center mt-14" data-id="element-238">
            <CtaButton label="Acceder a todas las recetas" data-id="element-239" />
          </div>
        </FadeIn>
      </div>
    </section>;
}